// @flow
import * as React from 'react';
import { EmptyCard } from 'components';

type Props = {
  authorized: boolean,
  children?: any,
};

export class CheckAuthorization extends React.Component<Props, void> {
  render() {
    const { authorized, children } = this.props;

    return authorized === true ? children : <EmptyCard.Unauthorized modal />;
  }
}

export default CheckAuthorization;



// WEBPACK FOOTER //
// ./src/pages/__components__/CheckAuthorization.js